import { Component, OnInit, Input } from '@angular/core';
import { NavLink } from '@classes/nav-link';

@Component({
    selector: 'app-home-cards',
    templateUrl: './home-cards.component.html',
    styleUrls: ['./home-cards.component.scss']
})
export class HomeCardsComponent implements OnInit {
    @Input() cards: NavLink[];

    constructor() { }

    ngOnInit() {
    }

}
